var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ((_obj = {}), (_obj["is-" + _vm.size] = true), _obj),
      attrs: { "data-component": "base-item-actions-popup" },
    },
    [
      _vm.actions.length
        ? _c(
            "div",
            {
              class: _vm.popupButtonState,
              attrs: { "data-button": "toggle-popup" },
              on: { click: _vm.onOpenClick },
            },
            [
              _c("or-icon", { attrs: { icon: "more_vert" } }),
              _vm._v(" "),
              _vm.isOpen
                ? _c(
                    "div",
                    { staticClass: "actions" },
                    _vm._l(_vm.actions, function (action) {
                      return _c(
                        "div",
                        {
                          key: action.key,
                          attrs: { "data-button": action.key },
                          on: {
                            click: function ($event) {
                              return _vm.onActionClick(action.key)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(action.label) + "\n      "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "description" }, [
            _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }